import getAllInstances from './getAllInstances.js';
import getSequenceData from './getSequenceData.js';

const utils = {
  getAllInstances,
  getSequenceData
};

export default utils;


// WEBPACK FOOTER //
// ./src/components/content/instanceScreenshotViewer/util/index.js